import React from "react";
import { Tooltip } from "react-tooltip";
import { styled } from "@sourceful/design-system";
import { gcsAssetFetcher, useCdnCacheKey } from "@lib/gcs";
import Image from "next/image";

const OptionWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  position: "relative",

  "input:checked + label": {
    border: `2px solid $palette1_colour1`,
  },

  "input:focus-visible + label": {
    border: "2px solid $colour-brand-blue-hue-1-base",
    boxShadow: " 0 0 0 4px #99BDF3 !important",
  },
  "text-white": {
    text: "white",
  },
});

const HiddenInput = styled("input", {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  opacity: 0,
});

const StyledLabel = styled("label", {
  background: "#DCDCDD",
  borderRadius: "$radii-medium",
  padding: 0,
  cursor: "pointer",
  color: "rgb(64, 64, 66)",
  overflow: "hidden",
  variants: {
    checked: {
      false: {
        border: "2px solid transparent",
      },
      true: {
        border: `2px solid $colour-brand-blue-hue-1-base !important`,
      },
    },
  },
});

interface ImagePreviewRadioProps {
  inputId: string;
  isChecked: boolean;
  value: string;
  handleChange: (value: string) => void;
  tooltipMessage?: string;
  imageUrl: string;
  tooltipId: string;
}

const ImagePreviewRadio = ({
  inputId,
  isChecked,
  value,
  handleChange,
  tooltipMessage,
  imageUrl,
  tooltipId,
}: ImagePreviewRadioProps) => {
  const cacheKey = useCdnCacheKey();
  // url is either from sanity cdn as complete url or from gcs bucket where url needs to be constructed
  const getImageUrl = (imageUrl: string) =>
    imageUrl.indexOf("https://") === 0
      ? imageUrl
      : gcsAssetFetcher.constructGCSurl(imageUrl, cacheKey, "publicAssets");

  return (
    <OptionWrapper className="image-preview-radio">
      {tooltipMessage && <Tooltip id={tooltipId} className={"text-white"} place={"top"} />}

      <StyledLabel
        data-for={tooltipId}
        data-tip={tooltipMessage}
        checked={isChecked ? "true" : "false"}
      >
        <HiddenInput
          id={inputId}
          type="radio"
          name="mode-switcher"
          checked={isChecked}
          value={value}
          onChange={() => {
            handleChange(value);
          }}
        />
        <Image
          src={getImageUrl(imageUrl)}
          width={40}
          height={40}
          alt={tooltipMessage ?? ""}
          loading="eager"
          priority
          unoptimized
        />
      </StyledLabel>
    </OptionWrapper>
  );
};

export default ImagePreviewRadio;
